import React, { useState } from "react";
import { Tabs, Tab, Box, Paper } from "@mui/material";
import Layout from "../../Layout";
import Dashboard from "./index";
import MaintenanceDashboard from "../MaintenanceDashboard";
import { checkPrivileges } from "../../Helpers";
import { useSelector } from "react-redux";
import GeofencesDashboard from "../GeofencesDashboard";
import ProductivityDashboard from "../ProductivityDashboard";



const MainDashboardFile = (props) => {
    const themecolors=useSelector((state)=>state.themeColors)
    const [activeTab, setActiveTab] = useState(0);
    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    if (!checkPrivileges("maintenanceDashboard")) {
        return (
            <Layout {...props} noSidebar classFromChildren={"has-padding no-sidebar dashboard-page"}>
                <Dashboard {...props}/>
            </Layout>
        );
    }
    return (
        <Layout {...props} noSidebar classFromChildren={"has-padding no-sidebar dashboard-page"}>
            <Box display="flex" justifyContent="start">
                <Paper 
                elevation={3} 
                    sx={{
      width: {
        xs: '100%',
        sm: '90%',
        md: '80%',
        lg: '74.5%',
        xl: '74.5%',
      },
      borderRadius: 2,
    }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleChange}
                        textColor={themecolors?.textColor||"#ffffff"}
                        indicatorColor="primary"
                        variant="fullWidth"
                        sx={{
                            "& .MuiTab-root": {
                                fontWeight: "bold",
                                color:themecolors?.textColor||"#ffffff",
                                backgroundColor:themecolors?.menuBackgroundColor||"#0A83A1",
                            },
                            "& .Mui-selected": {
                                color: themecolors?.menuActiveColor||"#ffffff",
                                backgroundColor:themecolors?.menuActiveBackground||"#045266",
                            },
                            "& .MuiTabs-indicator": {
                                backgroundColor:themecolors?.menuBackgroundColor||"#0A83A1",
                                color:themecolors?.textColor||"#ffffff",
                                height: 3,
                                borderRadius: 2,
                            },
                            "& .MuiTabs-flexContainer": {
                                overflow: "auto",
                                borderRadius:1
                            }
                        }}
                    >
                        <Tab sx={{ minWidth: "205px" }} label="Dashboard" />
                        <Tab sx={{ minWidth: "205px" }} label="Maintenance Dashboard" />
                        {checkPrivileges("geofenceDashboard")&&<Tab sx={{ minWidth: "205px" }} label="Geofences Dashboard" />}
                        {checkPrivileges("productivityDashboard")&&<Tab sx={{ minWidth: "205px" }} label="Productivity Dashboard" />}
                    </Tabs>
                </Paper>
            </Box>

            <Box sx={{ mt: 1}}>
                {activeTab === 0 && <Dashboard {...props}/>}
                {activeTab === 1 && <MaintenanceDashboard {...props}/>}
                {activeTab === 2 &&checkPrivileges("geofenceDashboard") && <GeofencesDashboard {...props}/>}
                {activeTab === 3 && <ProductivityDashboard {...props}/>}
            </Box>
        </Layout>
    );
};

export default MainDashboardFile;
